export default (id, value) => (dispatch, getState) => {
  dispatch({ type: 'FAVORITE_PORTFOLIO', id, pending: true });

  const { clientEmail, token } = getState();

  const body = {
    sedol: null,
    isin: null,
    cusip: null,
    clientEmail: clientEmail,
    favorite: value,
  };

  fetch(`${process.env.REACT_APP_DPD_URL}/portfolio/${id}/`, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: token &&
        `Token ${token}`,
    },
  })
    .then(d => d.json())
    .then(data => {
      dispatch({ type: 'FAVORITE_PORTFOLIO', id, value });
    })
    .catch(error => {
      console.error(error);
      dispatch({ type: 'FAVORITE_PORTFOLIO', id, pending: false });
    });
};



// WEBPACK FOOTER //
// ./src/actions/favorite-portfolio.js